import { ComponentProps, useEffect } from "react";
import * as S from "./styles";
import { Input } from "../../Atoms/Inputs/Input";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { Button } from "../../Atoms/Button";
import { useClientEdit } from "./useClientEdit";
import { ISelectOptions } from "../../../types/inputs";
import { IClienteDTO } from "../../../types/cliente";

interface IFormClientEditProps extends ComponentProps<"form"> {
  submitForm: (data: IClienteDTO) => void;
}

export const FormClientEdit = ({
  submitForm,
  ...rest
}: IFormClientEditProps) => {
  const {
    Controller,
    control,
    cidades,
    register,
    TipoOptions,
    ufOptions,
    watch,
    handleCep,
    handleSubmit,
  } = useClientEdit();

  return (
    <S.MyFormClientRegister {...rest} onSubmit={handleSubmit(submitForm)}>
      <div>
        <Input
          id="nome"
          {...register("nome")}
          variant="edit"
          label="Nome"
          required
        />
      </div>
      <div>
        <Input
          id="cpf"
          {...register("cpfCnpj")}
          label="CPF"
          disabled
          required
        />
      </div>
      <div>
        <Input
          id="email"
          {...register("email")}
          variant="edit"
          label="E-mail"
        />
      </div>
      <div>
        <Input
          id="telefone"
          {...register("telefone")}
          disabled
          label="Telefone"
          required
        />
      </div>
      <div>
        <Controller
          name="tipo"
          control={control}
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              required
              inputId="tipo"
              options={TipoOptions}
              label="Tipo"
              value={TipoOptions.find((i) => i.value === value) || null}
              onChange={(e: ISelectOptions) => onChange(e?.value)}
            />
          )}
        />
      </div>
      <div>
        <Input
          id="cep"
          {...register("endereco.cep")}
          variant="edit"
          label="CEP"
          maxLength={9}
          onBlur={handleCep}
          required
        />
      </div>
      <div>
        <Input
          id="rua"
          {...register("endereco.logradouro")}
          variant="edit"
          label="Endereço (Rua)"
          required
        />
      </div>
      <div>
        <Input
          id="numero"
          {...register("endereco.numero")}
          variant="edit"
          label="Número"
          required
        />
      </div>
      <div>
        <Input
          id="complemento"
          {...register("endereco.complemento")}
          variant="edit"
          label="Complemento"
        />
      </div>
      <div>
        <Input
          id="bairro"
          {...register("endereco.bairro")}
          variant="edit"
          label="Bairro"
          required
        />
      </div>
      <div>
        <Controller
          control={control}
          name="endereco.uf"
          render={({ field: { value, onChange } }) => (
            <SimpleSelect
              label="UF"
              options={ufOptions}
              required
              value={ufOptions.find((i) => i.value === value) || null}
              onChange={(e: ISelectOptions) => onChange(e?.value)}
            />
          )}
        />
      </div>
      <div>
        <Controller
          control={control}
          name="endereco.cidade"
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              key={watch("endereco.uf")}
              label="Cidade"
              required
              options={cidades}
              onChange={(e: ISelectOptions) => onChange(e?.value)}
              value={cidades.find((i) => i.value === value) || null}
            />
          )}
        />
      </div>
      <div>
        <Button>Salvar</Button>
      </div>
    </S.MyFormClientRegister>
  );
};
